import classes from './NavBar.module.css';

/** ロゴ + ロゴタイプ。ナビとフッターで共用する。 */
const HomeIcon = ({ variant = 'nav' }) => {
  return (
    <a className={classes.Brand} href="/" aria-label="飯田建築 トップページ">
      <img
        src="/images/logo_green_no_title.png"
        alt="飯田建築"
        style={variant === 'footer' ? { height: 36, background: '#fff', padding: 4 } : undefined}
      />
      <b style={variant === 'footer' ? { color: '#fff' } : undefined}>飯田建築</b>
    </a>
  );
};

export default HomeIcon;
